import React from 'react';
import 'date-fns';
import './App.css';
import {CssBaseline, Typography, IconButton, Dialog, Grid, withStyles, Button, Input, TextField, FormControl, Select, InputLabel} from '@material-ui/core'
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import {isMobileOnly, CustomView , isMobile} from 'react-device-detect';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { AddCircleOutlineOutlined, RemoveCircleOutline } from '@material-ui/icons';
import Paper from '@material-ui/core/Paper';
import ccyFormat from './ccyFormat';
import { MobileDateTimePicker, LocalizationProvider} from '@material-ui/pickers';
import DateFnsUtils from '@material-ui/pickers/adapter/date-fns';
import {
  ThemeProvider,
  createMuiTheme,
} from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import fire from './fire'
import promoApply from './promoApply';
import initMB from 'messagebird';


  const barWidth = () => {
    if (isMobile) return '100vw'
    else return '70vw'
  }
  
  const textSize1 = () =>{
    if (isMobileOnly) return 'h5'
    else return 'h4'
  }
  
  const textSize2 = () =>{
    if (isMobileOnly) return 'h7'
    else return 'h6'
  }

  const timeFormat = () => {
    if (isMobileOnly) return "dd/MM HH:mm"
    else return "dd/MM/yyyy HH:mm"
  }
  
 const buttonSize = () => {
   if (isMobileOnly) return 'small'
   else return 'medium'
 }

 const amountRow = () => {
  if (isMobileOnly) return '25vw'
  else return ''
 }
  
  const customWidth = () => {
    if (isMobileOnly) return '33vw'
    else return '14vw'
  }

  const spanRender = () => {
    if (isMobileOnly) return '2'
    else return '3'
  }

  const styles = theme => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    
  });
  
  const DialogContent = withStyles(theme => ({
    root: {
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);

  const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h5">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  const useStyles = makeStyles({
  
      ContentBackground:{
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#282c34',
        height: '80vh',
        overflow: 'auto',
        display: 'flex',
        width:'100vw',
        textAlign: 'center',
        verticalAlign: 'middle',
        flexDirectison: 'columns',
      },

      containerStyle: {
        height: '80vh',
        overflow: 'auto',
        textAlign : 'center',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
      },
  
      title: {
        marginTop: '2vh',
        marginLeft: '2vw',
        color: 'black',
        display: 'flex',
        fontFamily:'Roboto',
        fontStyle: 'oblique',
        fontWeight: 'bold'
      },
  
      card: {
        maxWidth: customWidth(),
      },
  
      inputCenter: {
        textAlign: "center",
        color: "red"
      }
    });
  
  const useThemes = makeStyles(theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.paper,
    },
    gridList: {
      width: '30vw',
      height: '30vh',
    },
    icon: {
      color: 'rgba(255, 255, 255, 0.54)',
    },
    priceRow: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'table-cell',
      },
    },
    
    rootPromo: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    margin: {
      margin: theme.spacing(1),
    },
  }));

  const theme = createMuiTheme({
    palette: {
      primary: green,
    },
  });

export default function Cart({cartList, cartEmpty, shopList, onAdd, onMinus, onRemove, handleChange, isCheckOut, checkOut, subTotal, delivery, deliFee, total, applyPromo, discount, onFinish}) {
    const classes = useThemes();
    const styleClasses = useStyles();  
    const [name, setName] = React.useState(localStorage.getItem('userName') || '');
    const [location, setLocation] = React.useState(localStorage.getItem('current-address'))
    const [phoneNo, setPhone] = React.useState(localStorage.getItem('phoneNo') || '');
    const [enterCode, setPromo] = React.useState('')
    const [payment, setPayment] = React.useState('Cash');
    var [dateTime, setDateTime] = React.useState([]);
    const [isTimeValid,setValid] = React.useState(false);
    const [errorOpen,setOpenError] = React.useState(false);
    const [finishOpen,setFinishOpen] = React.useState(false);
    const [erroMsg, setMsg] = React.useState('')

    const onTimeChange = (date, name) => {
      const index = shopList.findIndex(arg => arg.Seller === name )
      shopList[index].dateTime = date;
      let newState = [];
      for (let items in shopList) {
        const dateValue = shopList[items].dateTime;
        newState[shopList[items].Seller] = dateValue;
      }     
      setDateTime(newState) 
    }

    const disableDay = (date, days) => {
      let notAvailable = true;
      if (days){
      for (let items in days) {
        if (date.getDay() === Number(days[items])) { 
          notAvailable = false
          break;
        }
      }}
      else notAvailable = false
      return notAvailable
    }

    const openTime = (times) => {
      if (times) return(new Date(0,0,0,times['Open'].Hour, times['Open'].Min)) 
      //else return new Date(0,0,0,0,0)
    }

    const closeTime = (times) => {
      if (times) return(new Date(0,0,0,times['Close'].Hour, times['Close'].Min)) 
     // else return new Date(0,0,0,24,0)
    }

    const paymentOption = () => event => {
      event.preventDefault();
      setPayment(event.currentTarget.value)
    }

    const errorClose = () => setOpenError(false)

    const finishClose = ()  => {
      setFinishOpen(false);
      onFinish()
    }

    const onOrder = () => event => {
      event.preventDefault();
      if (name === '') {
        setMsg('name')
        setOpenError(true)
      }
      else if (phoneNo === ''){
        setMsg('phone number')
        setOpenError(true)
      }
      else if (location === ''){
        if (delivery.findIndex(arg => arg.collect !== "Pick-up") !== -1) {
        setMsg('location')
        setOpenError(true)
        }
        else setLocation('N/A')
      }
      else {
          for (let items in shopList){
            if (shopList[items].dateTime) {
              setValid(true)
            }
            else {
              setMsg('Pick-up / Deliver Time')
              setOpenError(true)
              setValid(false)
              break;
            }
          }
        }

      if (name !== '' && location !== '' && phoneNo !== '' && isTimeValid) {

    
        let Order = []
        for (let items in cartList){
          let dummy = cartList[items]

          for (let item in dummy){
              let newValue = Number(dummy[item].Available) - dummy[item].Amount;
              let itemKey = dummy[item].ItemKey;
              fire.database().ref(`Shop/${dummy[item].SellerID}/Menu/${itemKey}`).update({Available: newValue})
              delete dummy[item].Seller
              delete dummy[item].Available
              delete dummy[item].Size
              delete dummy[item].Extra
          }
          Order[items] = dummy
          const index = shopList.findIndex(arg => arg.Seller === items)
          Order[items].Promo = Number(shopList[index].Promo) || 0
          Order[items].shopTotal = shopList[index].shopTotal
          Order[items].timeCollect = String(shopList[index].dateTime || new Date())
          Order[items].request = String(shopList[index].request || '')
          Order[items].status = 'Pending'
          
        }
        let orderTime = String(new Date());
        if (total >= 0) { fire.database().ref('UserOrder/').push({
          name: name,
          location: location,
          phoneNo: phoneNo,
          order: Order,
          collect: delivery,
          deliveryFee: deliFee,
          discount: discount,
          total: total,
          payment: payment,
          orderTime: orderTime,
        });}
        else { fire.database().ref('UserOrder/').push({
          name: name,
          location: location,
          phoneNo: phoneNo,
          order: Order,
          collect: delivery,
          deliveryFee: deliFee,
          discount: discount,
          total: (0).toFixed(2),
          payment: payment,
          orderTime: orderTime,
        })
          
        }

        let numberOrder = parseInt(localStorage.getItem('numberOrder') || 0) ;
        localStorage.setItem('numberOrder', numberOrder + 1)
        localStorage.setItem('userName', name);
        localStorage.setItem('phoneNo', phoneNo);
        localStorage.setItem(`orderName_${numberOrder + 1}`, name)
        localStorage.setItem(`orderTime__${numberOrder + 1}`, orderTime);

        if (localStorage.getItem('ReturnOrder') === 'Yes') {
          fire.database().ref(`WebCount`).once('value',(snapshot)=>{
            let item = Number(snapshot.val().ReturnOrder);
            if ((!(localStorage.getItem('username')) && !(localStorage.getItem('sellerUsername')))) fire.database().ref(`WebCount`).update({ReturnOrder: item+1})
          })
        }
        else localStorage.setItem('ReturnOrder', 'Yes')

        const messagebird = initMB('nzEWPzyAB7PnzEufrRBOoOp6S');
        for (let index in shopList) {
          var params = {
            'originator': '+61488863481',
            'recipients': [
              `${shopList[index].Contact}`
          ],
            'body': `Your shop '${shopList[index].Seller}' on BimBim has a new order. This is a system message. Do not reply to this number.`
          };

          messagebird.messages.create(params, function (err, response) {
            if (err) {
              fire.database().ref('Error/').push({err})
              return console.log(err);
            }
          });
        }

        setFinishOpen(true);   
      }
    }

    const fillInform = (fillType,name) => event => {
      event.preventDefault();
      if (fillType === 'name') setName(event.currentTarget.value);
      if (fillType === 'location') setLocation(event.currentTarget.value);
      if (fillType === 'phoneNo') setPhone(event.currentTarget.value);
      if (fillType === 'request') 
      { 
        const index = shopList.findIndex(arg => arg.Seller === name)
        shopList[index].request = event.currentTarget.value;
      }
    }

    const checkPromo = () => event => {
      event.preventDefault();
      setPromo(event.currentTarget.value);
      const promoCode = event.currentTarget.value;
      fire.database().ref('Promo').orderByChild('Code').equalTo(promoCode).once('value', (snapshot)=>{
        let databaseCode = snapshot.val();
        let discountArray = [];
        if (databaseCode) {
          discountArray = promoApply(databaseCode,deliFee,subTotal,cartList,shopList, delivery)
          console.log(discountArray)
          if (discountArray) applyPromo(discountArray)
          setPromo('')
        }
      })
    }

    const returnTime = (arg) => {
      if (arg) return arg
      else return null
    }

    return (
      <div className = {styleClasses.ContentBackground}>
        <div className ={styleClasses.containerStyle} style={{width: barWidth() }}>
        <CustomView condition = {!cartEmpty}>
        { shopList.map(items => (
        <div>
          <div style ={{backgroundColor: 'lightgray'}}>
            <Typography className={styleClasses.title} variant= {textSize2()} noWrap>
                {items.Seller}
            </Typography>
          </div>
          <TableContainer component={Paper}>
          <Table aria-label="simple table">
          <TableHead>
          <TableRow>
            <TableCell>Snack</TableCell>
            <TableCell>Name</TableCell>
            <TableCell style = {{minWidth: amountRow()}} size = 'medium' align="center">Amount</TableCell>
            <TableCell className = {classes.priceRow} align="right">Price&nbsp;(AUD)</TableCell>
            <TableCell size = {buttonSize()} align="right">Sum&nbsp;(AUD)</TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {cartList[items.Seller].map(item => (
            <TableRow key={item.Name}>
            <TableCell scope = 'row'>
                <img style ={{height: '8vh'}} src = {item.ImageLink} alt = {item.Name}/>
            </TableCell>
            <TableCell scope="row">
                {item.Name}
            </TableCell>
            <TableCell style={{minWidth: amountRow()}} size = 'medium' align="center">
              <IconButton size = {buttonSize()}>
                <RemoveCircleOutline fontSize = {buttonSize()} onClick = {onMinus(items.Seller, item.Name)}/>
              </IconButton>
                {item.Amount}
              <IconButton size = {buttonSize()}>
                <AddCircleOutlineOutlined fontSize = {buttonSize()} onClick = {onAdd(items.Seller, item.Name)}/>
              </IconButton>
              </TableCell>
              <TableCell className = {classes.priceRow}  align="right">
              <Typography color= 'goldenrod'>
                {ccyFormat(Number(item.Price))}
                </Typography>
              </TableCell>
              <TableCell size = {buttonSize()} align="right">
                <Typography color= 'goldenrod'>
                {ccyFormat(item.Total)}
                </Typography>
              </TableCell>
              <TableCell align="center">
              <Button size = {buttonSize()} color="primary" onClick={onRemove(items.Seller, item.Name)}>Remove</Button>
              </TableCell>
            </TableRow>
        ))}
        <TableRow>
            <TableCell colSpan={spanRender()} />
            <TableCell>
            <Typography style={{ fontWeight: 'bold'}}>
                Total:
            </Typography>
            </TableCell>
            <TableCell align="right">
            <Typography variant='h6' style={{color: 'goldenrod', fontWeight: 'bold'}}>
                {ccyFormat(items.shopTotal)}
            </Typography>
            </TableCell>
          </TableRow>
         </TableBody>
      </Table>
    </TableContainer>
    <p></p>
    </div>
    ))}
      </CustomView>
      <Dialog 
      style = {{height: 'auto'}}
      scroll = {"body"}
      fullWidth={true}
      maxWidth={'sm'}
      fullScreen={isMobileOnly}
      onClose={checkOut(false)} 
      aria-labelledby="customized-dialog-title" 
      open={isCheckOut}>
            <DialogTitle style ={{overflow: 'hidden'}} id="customized-dialog-title" onClose={checkOut(false)}></DialogTitle>
            <DialogContent style ={{overflow: 'hidden'}}>  
              <Input defaultValue={name} onChange={fillInform('name')} fullWidth={true} type= "text" placeholder="Name" inputProps={{ 'aria-label': 'name' }} />
            </DialogContent>
            <DialogContent style ={{overflow: 'hidden'}}>
              <Input disabled={true} defaultValue={location} onChange={fillInform('location')} fullWidth={true} placeholder="Location" inputProps={{ 'aria-label': 'location' }} />
            </DialogContent>
            <DialogContent style ={{overflow: 'hidden'}}>
              <Input defaultValue={phoneNo} onChange={fillInform('phoneNo')} fullWidth={true} type="number" placeholder="Phone No" inputProps={{ 'aria-label': 'phoneNo' }} />
            </DialogContent>

          { shopList.map(items => (
            <DialogContent style ={{overflow: 'hidden'}}>
            <Grid container spacing={2}>
            
              <Grid item xs={6} wrap ="nowrap">
                <InputLabel htmlFor="age-native-helper" shrink = {true}>
                    {items.Seller}
                </InputLabel>
                  <Select
                    native
                    onChange = {handleChange(items.Seller)}
                    value={items['Method'].value}
                    inputProps={{
                      name: items.Seller,
                      id: 'outlined-age-native-simple',
                  }}> 
                  { items.Method.map(item => <option value={item.value}>{item.Description}</option>)}
                 </Select>
              </Grid>
              
              <Grid item xs = {6} wrap ="nowrap" >
              <LocalizationProvider dateAdapter={DateFnsUtils}>
                <MobileDateTimePicker
                    ampm={true}
                    value = {returnTime(dateTime[items.Seller])}
                    onChange={date  => onTimeChange(date, items.Seller)}
                    label = 'Date & Time'
                    variant="outlined"
                    disablePast
                    minTime = {openTime(items.AvailableTime)}
                    maxTime = {closeTime(items.AvailableTime)}
                    shouldDisableDate = {date => disableDay(date,items.AvailableDay)}
                    format= {timeFormat()}
                  />
              </LocalizationProvider>
                </Grid>
            </Grid>
            <p></p>
            <TextField variant = 'outlined' onChange={fillInform('request', items.Seller)} multiline={true} rowsMax={2} required = {true} fullWidth={true} placeholder={`Special request for ${items.Seller}`} inputProps={{ 'aria-label': 'request', maxlength: 150 }} />
            </DialogContent>
            ))}
          <DialogContent style={{overflow: 'hidden'}}>
          <Grid container spacing={1}>
            <Grid item xs wrap ="nowrap">
                <Typography>
                    Payment option:
                </Typography>
              </Grid>
              <Grid item xs wrap ="nowrap">
              <FormControl style ={{display: 'inherit'}} >
              <Select
              onChange = {paymentOption()}
              native
              inputProps={{
                  name: 'payment',
                  id: 'outlined-age-native-simple',
              }}> 
              
              <option value={'Cash'}>Cash</option>
              <option value ={'Bank Transfer'}>Bank transfer</option>
              </Select>
              </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogContent style ={{overflow: 'hidden'}}>
            <Grid container spacing={2} >
              <Grid item xs wrap ="nowrap">
              <TableContainer component={Paper}>
              <Table aria-label="simple table">
              
              <TableBody>
              <TableRow>
              <TableCell scope = 'row'>
                <Typography>
                  Subtotal:     
                </Typography>
              </TableCell>
              <TableCell>
                <Typography style={{textAlign:'right'}}>
                 {ccyFormat(subTotal)}
                </Typography>
              </TableCell>
              </TableRow>

              <TableRow>
              <TableCell scope = 'row'>
                <Typography>
                  Delivery:     
                </Typography>
              </TableCell>
              <TableCell>
                <Typography style={{textAlign:'right'}}>
                 {deliFee}
                </Typography>
              </TableCell>
              </TableRow>
              <TableRow>
              <TableCell scope = 'row'>
                <Typography>
                  Discount:    
                </Typography>
              </TableCell>
              <TableCell>
                <Typography style={{textAlign:'right', fontWeight: 'bold', color: 'red'}}>
                 {discount}
                </Typography>
              </TableCell>
              </TableRow>

              <TableRow>
              <TableCell scope = 'row'>
                <Typography style ={{fontWeight: 'bold'}}>
                  Total:    
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='h5' style={{textAlign:'right', fontWeight: 'bold', color: 'goldenrod'}}>
                 {total}
                </Typography>
              </TableCell>
              </TableRow>
                </TableBody>
                </Table>
                </TableContainer>
              </Grid>

              <Grid item xs wrap ="nowrap">
              <TableContainer component={Paper}>
              <Table aria-label="simple table">
              <TableBody>

              <TableRow>
              <TableCell scope = 'row'>
           
              <ThemeProvider theme={theme}>
              <TextField
                className={classes.margin}
                label="Promo"
                variant="outlined"
                fullWidth = {true}
                value = {enterCode}
                onChange =  {checkPromo()}
                id="Promo-code-input"
              />
              </ThemeProvider>

              </TableCell>
              </TableRow>

              <TableRow>
              <TableCell scope = 'row'>
              <DialogActions>
              <Button fullWidth = {true} variant="contained" color="primary" onClick={onOrder()}>
                Order Now
              </Button>
              </DialogActions>
              </TableCell>
              </TableRow>

              </TableBody>
              </Table>
              </TableContainer>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
        <Dialog
        open={errorOpen}
        onClose={errorClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title"></DialogTitle>
        <DialogContent>
          <Typography style = {{ fontWeight: 'bold'}}>
            Your {erroMsg} is missing. Please re-check your information
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={errorClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
        </Dialog>
        <Dialog
        open={finishOpen}
        onClose={finishClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
        <DialogTitle id="alert-dialog-title">Thank you</DialogTitle>
        <DialogContent>
          <Typography>
            Đơn hàng đã được ghi nhận. Bạn có thể xem tình trạng hoặc hủy đơn hàng 'Pending' hay liên lạc với người bán hàng bằng cách nhấn vào tên shop ở mục Profile.
          </Typography>
          <p></p>
          <Typography>
            Nhấn 'Bank Detail' ở mục Profile để xem thông tin chuyển khoản. Khách hàng vui lòng chuyển khoản và chụp hình lại để xác nhận. 
          </Typography>
          <p></p>
          --------------------------------------------------
          <p></p>
          <Typography>
            Your snack will be ready soon. You can check your orders status or cancel 'Pending' orders, or contact the seller by click on the shop in the Profile tab.
          </Typography>
          <p></p>
          <Typography>
            Cick on "Bank Detail" in the Profile tab for Bank Transfer Info, make the payment and keep a photo as proof of the transaction. 
          </Typography>
        </DialogContent>
        <DialogActions>
        <Button onClick={finishClose} color="secondary" autoFocus>
            Back to menu
        </Button>
        </DialogActions>
      </Dialog>
        <CustomView condition = {cartEmpty} >
          <div className= 'logoContent'>
            <img className = 'App-logo' src={'./bim192.png'} alt="logo"  />
            <p></p>
            <Typography variant={textSize1()} noWrap>
                Your cart is empty !!!
            </Typography>
          </div>
        </CustomView>
        </div>
        <CssBaseline/>
    </div>
    );
}